import React, { useEffect, useState } from 'react';
import {Container, Grid, Typography, Button,  Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, MenuItem, Select, FormControl, InputLabel, TextField, Alert, Box} from '@mui/material';
import { Delete as DeleteIcon, ConfirmationNumber as TicketIcon } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import services from 'src/services/Services';
import UserService from 'src/services/UserService';
import InstanceDataUser from 'src/services/InstanceDataUser';
import singletonSession from 'src/services/IntanceSession';
import WidgetAlert from 'src/widgets/WidgetAlert';
import tokenService from 'src/services/tokenService';

const AdminTokens = () => {
    const [dataTokens, setDataTokens] = useState([]);
    const [dataClients, setDataClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rol, setRol] = useState('');
    const [user, setUser] = useState('');
    const [selectUser, setSelectUser] = useState('');
    const [isVisibleSelect, setIsVisibleSelect] = useState(false);

    const [createdToken, setCreatedToken] = useState('');
    const [openTokenDialog, setOpenTokenDialog] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const [selectedToken, setSelectedToken] = useState({
        UserName: '',
        AccessUuid: '',
        Expires: '',
    });

    const [alert, setAlert] = useState({
        open: false,
        type: 'success',
        message: '',
    });

    useEffect(() => {
        const currentUser = UserService.gerUser();
        setUser(currentUser);

        const roleName = InstanceDataUser.getRol();
        setRol(roleName);

        if (roleName === 'Administrador') {
            setIsVisibleSelect(true);
            getTokens();
            getClients();
        } else {
            setIsVisibleSelect(false);
            getUserTokens(currentUser);
        }
    }, []);

    useEffect(() => {
        if (openTokenDialog && createdToken) {
            navigator.clipboard.writeText(createdToken);
        }
    }, [openTokenDialog, createdToken]);

    const getClients = async () => {
        const response = await services.getUsersMysql();
        setDataClients(response.data);
    };

    const getTokens = async () => {
        const response = await services.getAllTokens();
        setDataTokens(response.data);
        setLoading(false);
    };

    const getUserTokens = async (username) => {
        const body = { Username: username };
        const response = await services.getUserTokens(body);
        setDataTokens(response.data);
        setLoading(false);
    };

    const handleSelectUser = (e) => {
        const name = e.target.value;
        setSelectUser(name);
        singletonSession.setUser(name);
    };

    const handleCreateToken = async () => {
        if (isVisibleSelect && !selectUser) {
            setAlert({
                open: true,
                type: 'warning',
                message: '¡Por favor seleccione un usuario!',
            });
            return;
        }

        try {
            const res = await tokenService.createToken(
                isVisibleSelect ? selectUser : null
            );

            setCreatedToken(res.data.AccesToken);
            setOpenTokenDialog(true);

            setAlert({
                open: true,
                type: 'success',
                message: '¡Se creó el token con éxito!',
            });

            isVisibleSelect ? getTokens() : getUserTokens(user);

        } catch {
            setAlert({
                open: true,
                type: 'error',
                message: 'Error al crear token',
            });
        }
    };

    const handleDeleteToken = async () => {
        const body = {
            Username: selectedToken.UserName,
            AccessUuid: selectedToken.AccessUuid,
        };

        try {
            await services.deleteToken(body);
            setAlert({
                open: true,
                type: 'success',
                message: '¡Se eliminó el token con éxito!',
            });
            setOpenModal(false);

            if (rol === 'Administrador') getTokens();
            else getUserTokens(user);
        } catch {
            setAlert({
                open: true,
                type: 'error',
                message: 'Error al eliminar el token',
            });
        }
    };

    const columns = [
        { field: 'IDClient', headerName: 'ID Cliente', flex: 1 },
        { field: 'UserName', headerName: 'Nombre', flex: 2 },
        { field: 'AccessCreateAt', headerName: 'Fecha Creación', flex: 2 },
        { field: 'Expires', headerName: 'Vigencia', flex: 2 },
        {
            field: 'acciones',
            headerName: 'Eliminar',
            flex: 1,
            renderCell: (params) => (
                <DeleteIcon
                    sx={{
                        cursor: 'pointer',
                        color: 'text.secondary',
                        transition: 'color .15s ease',
                        '&:hover': { color: 'error.main' }
                    }}
                    onClick={() => {
                        setSelectedToken(params.row);
                        setOpenModal(true);
                    }}
                />
            ),
        },
    ];

    return (
        <Container maxWidth="lg" sx={{ mt: 4 }}>
            <WidgetAlert
                open={alert.open}
                type={alert.type}
                message={alert.message}
                onClose={() => setAlert({ ...alert, open: false })}
            />

            <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
                <Grid item>
                    <Typography variant="h4" fontWeight={700}>
                        Administración de Tokens
                    </Typography>
                </Grid>
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {isVisibleSelect && (
                        <FormControl size="small" sx={{ minWidth: 220 }}>
                            <InputLabel>Seleccione usuario</InputLabel>
                            <Select
                                value={selectUser}
                                label="Seleccione usuario"
                                onChange={handleSelectUser}
                            >
                                <MenuItem value="">
                                    <em>Seleccione un usuario...</em>
                                </MenuItem>
                                {dataClients.map((client) => (
                                    <MenuItem key={client.ID} value={client.short_name}>
                                        {client.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    <Button
                        variant="contained"
                        startIcon={<TicketIcon />}
                        onClick={handleCreateToken}
                        sx={{
                            borderRadius: 3,
                            px: 3,
                            boxShadow: '0 8px 26px rgba(85,108,214,0.16)',
                            background: 'linear-gradient(120deg,#556cd6, #4dd0e1)',
                            color: '#fff',
                            textTransform: 'none',
                            fontWeight: 700,
                            transition: 'transform .16s ease, box-shadow .16s ease',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 14px 40px rgba(85,108,214,0.2)'
                            },
                            '& .MuiButton-startIcon': { mr: 0.6 }
                        }}
                    >
                        Generar token
                    </Button>
                </Grid>
            </Grid>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box sx={{ background: '#fff', borderRadius: 3, p: 1 }}>
                    <DataGrid
                        rows={dataTokens}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[5, 10, 20]}
                        autoHeight
                        disableSelectionOnClick
                        getRowId={(row) => row.AccessUuid}
                    />
                </Box>
            )}

            <Dialog open={openModal} onClose={() => setOpenModal(false)}>
                <DialogTitle fontWeight={700}>Eliminar Token</DialogTitle>
                <DialogContent>
                    ¿Eliminar el token de <b>{selectedToken.UserName}</b> con vigencia{' '}
                    <b>{selectedToken.Expires}</b>?
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={handleDeleteToken}>
                        Aceptar
                    </Button>
                    <Button variant="outlined" onClick={() => setOpenModal(false)}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openTokenDialog} maxWidth="md" fullWidth>
                <DialogTitle fontWeight={700}>Token generado</DialogTitle>
                <DialogContent>
                    <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }}>
                        El token ya fue copiado al portapapeles.
                        Guárdelo en un lugar seguro, no podrá visualizarse nuevamente.
                    </Alert>

                    <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        value={createdToken}
                        InputProps={{ readOnly: true }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setOpenTokenDialog(false);
                            setCreatedToken('');
                        }}
                    >
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default AdminTokens;
